export default "__VITE_ASSET__B$1ecp8H__"